import React from "react";
import { keyframes } from "@emotion/core";
import { RiLoader4Line } from "react-icons/ri";
import { connect } from "react-redux";

import isBrowser from "../../utils/isBrowser";

const NewFeedback = ({ me, org, onCreate }) => {
    const [ processing, setProcessing ] = React.useState(undefined);

    const [ title, setTitle ] = React.useState("");
    const [ details, setDetails ] = React.useState("");

    const createFeedback = () => {
        if (!(title && details)) return;

        setProcessing(true);

        if (!isBrowser()) return;

        window.fetch(process.env.API_URL + "/orgs/" + org._id + "/feedback", {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": me.token,
            },
            body: JSON.stringify({
                title,
                details,
            }),
        }).then(res => {
            if (res.ok) return res.json();
            throw new Error(res.statusText);
        }).then(feedback => {
            setProcessing(false);
            setTitle("");
            setDetails("");
            onCreate(feedback);
        }).catch((e) => {
            console.error(e);
            setProcessing(false);
        });
    };

    return (
        <div css={{
            top: 0,
            position: "sticky",
            display: "flex",
            flexDirection: "column",
            padding: 15,
            borderRadius: 3,
        }}>
            <div css={{
                marginBottom: 15,
                padding: 10,
                backgroundColor: "rgba(100, 100, 100, .2)",
                borderRadius: 3,
            }}>
                <div css={{
                    marginBottom: 5,
                    color: "rgba(200, 200, 200, .5)",
                    fontSize: ".7em",
                    fontWeight: 500,
                    textTransform: "uppercase",
                }}>
                    Title
                </div>
                <input
                    type="text"
                    placeholder="Short, descriptive title"
                    value={ title }
                    maxLength={ 128 }
                    css={{
                        width: "100%",
                        fontSize: ".8em",
                        backgroundColor: "transparent",
                        border: "none",
                        ":invalid": {
                            backgroundColor: "var(--red)",
                        },
                    }}
                    onChange={ (e) => setTitle(e.target.value) }
                />
            </div>

            <div css={{
                marginBottom: 15,
                padding: 10,
                backgroundColor: "rgba(100, 100, 100, .2)",
                borderRadius: 3,
            }}>
                <div css={{
                    marginBottom: 5,
                    color: "rgba(200, 200, 200, .5)",
                    fontSize: ".7em",
                    fontWeight: 500,
                    textTransform: "uppercase",
                }}>
                    Details
                </div>
                <textarea
                    type="text"
                    placeholder="Any additional details..."
                    rows={ 5 }
                    value={ details }
                    maxLength={ 2048 }
                    css={{
                        width: "100%",
                        resize: "none",
                        fontSize: ".8em",
                        backgroundColor: "#202020",
                        border: "none",
                    }}
                    onChange={ (e) => setDetails(e.target.value) }
                />
            </div>

            <div>
                <button
                    disabled={ !(me && me.token && title && details) }
                    css={{
                        width: "100%",
                        fontSize: ".8em",
                        color: "var(--light)",
                        backgroundColor: "rgba(100, 100, 100, .2)",
                        transition: "background-color var(--transition-default-time) ease-out",
                        ":not(:disabled):hover": {
                            backgroundColor: "rgba(100, 100, 100, .5)",
                        },
                        ":disabled": {
                            color: "darkgrey",
                            cursor: "not-allowed",
                        },
                    }}
                    onClick={ createFeedback }
                >
                    {
                        processing
                        ?   <RiLoader4Line
                                css={{
                                    animation: `${keyframes({
                                        from: {
                                            transform: "rotate(0deg)",
                                        },
                                        to: {
                                            transform: "rotate(360deg)",
                                        },
                                    })} .8s linear infinite`,
                                }}
                            />
                        :   me && me.token
                            ?   "Create a Post"
                            :   "Login to Post"
                    }
                </button>
            </div>
        </div>
    );
};

export default connect(
    state => ({ me: state.global.me, org: state.global.org }),
    null
)(NewFeedback);
